import OrderDetail from "./orderDetails.container";

export default OrderDetail;
